var React = require('react');

function IconCopySolid (props) {
    return React.createElement("svg",props,[React.createElement("g",{"fill":"#0A0101","key":0},[React.createElement("path",{"d":"M923.683 219.093L756.79 50.625h-1.501v168.468z","key":0}),React.createElement("path",{"d":"M485.74 50.625v606.487h438.019V286.481H720.805c-18.608 0-32.902-15.761-32.902-34.368V50.625H485.74zM776.89-16.199l-.134-.134h-.633c.256.041.512.087.767.134zM418.394 707.637v16.434h.039z","key":1})]),React.createElement("path",{"d":"M417.532 724.5V174.598H107.21v740.403h572.713V724.5z","key":1})]);
}

IconCopySolid.displayName = "IconCopySolid";

IconCopySolid.defaultProps = {"viewBox":"15.167 -16.333 1000.636 1000.678"};

module.exports = IconCopySolid;

IconCopySolid.default = IconCopySolid;
